import React, { FC, ReactNode } from 'react';

// Components
import { ErrorBoundary } from 'react-error-boundary';
import FallbackErrorV2 from '@velinsi/smp-widgets-ui/src/molecules/FallbackError/FallbackError';

// Types
import { THEME_VARIANTS, Themes } from '../types';

type Properties = {
  children: ReactNode;
  dataTheme?: Themes | null;
};

export const ErrorBoundaryWrapper: FC<Properties> = ({ children, dataTheme }) => {
  return <ErrorBoundary fallback={<FallbackErrorV2 dataTheme={dataTheme ?? THEME_VARIANTS.LIGHT} />}>{children}</ErrorBoundary>;
};
